import React, { useState, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { RxUpload, RxDownload } from "react-icons/rx";

function ImportCSV(props) {
  const [passwordType, setpasswordType] = useState("APIs");
  return (
    <Modal
      isOpen={props.csvModal}
      toggle={props.csvModaltoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={props.csvModaltoggle}>
        Import CSV
      </ModalHeader>
      <ModalBody>
        <Form>
          <div className="formElmWrap">
            <Input
              id="exampleSelect"
              name="select"
              type="select"
              onChange={(e) => {
                setpasswordType(e.target.value);
              }}
            >
              {/* <option>Choose...</option> */}
              <option value="APIs">APIs</option>
              <option value="Database Access">Database Access</option>
              <option value="Web Applications">
                Web Applications
              </option>
              <option value="Server Access">Server Access</option>
              <option value="Cloud Services">Cloud Services</option>
              <option value="Others">Others</option>
            </Input>
          </div>
          <Button
            color="outline-blue downloadBtn"
            style={{ margin: "15px 0 15px 0 " }}
            onClick={() => props?.csvDownload(passwordType)}
          >
            <span className="formIcon">{<RxDownload />}</span>
            Download Sample CSV File
          </Button>

          <div className="formElmWrap fileWrap">
            <Input
              id="csv"
              name="csv"
              placeholder="Upload CSV File"
              type="file"
              onChange={(e) => props.onFileChange(e)}
              accept=".csv"
            />
            <span className="formIcon">{<RxUpload />}</span>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => props.uploadCsv()}>
          Submit
        </Button>
        <Button color="outline" onClick={props.csvModaltoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ImportCSV;
